<template>
  <div>

    <v-dialog
      v-model="dialog.loading.visible"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text
          class="pt-5 white--text"
        >
          <p>{{ dialog.loading.content }}</p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.response.visible"
      width="410"
    >
      <v-card
        class="text-left"
      >
        <v-img
          class="red--text darken-2"
          height="150px"
          :src="dialog.response.banner"
        ></v-img>

        <v-card-title class="px-5 pb-2 headline">
          {{ dialog.response.title }}
        </v-card-title>

        <v-card-text
          class="px-5 subtitle-1"
        >
          {{ dialog.response.content }}
        </v-card-text>

      </v-card>
    </v-dialog>


    <v-card
      tile
      class="my-4 mx-sm-4 mx-md-9"
    >
      <v-tabs
        height="60"
        grow
        dark
        background-color="primary"
        v-model="selectedTab"
      >
        <v-tab
          :disabled="$store.getters.hasLoggedin"
        >
          <i class="material-icons">add</i> &nbsp; &nbsp;
          <span class="title font-weight-regular text-capitalize">New Student</span>
        </v-tab>
        <v-tab
          :disabled="!$store.getters.hasLoggedin"
        >
          <i class="material-icons">person</i> &nbsp; &nbsp;
          <span class="title font-weight-regular text-capitalize">Returning Student</span>
        </v-tab>


        <v-tab-item
          class="py-5 px-8 text-left"
        >

          <p class="title font-weight-light grey--text darken-2">
            Sign up for a student account in our learner portal to access all information about your training material and manage your qualifications.
          </p>

          <v-row>
            <v-col
              cols="12"
              md="6"
              class="py-0 pr-md-4"
            >
              <v-text-field
                label="First Name *"
                v-model="register.firstname"
                @input="$v.register.firstname.$touch()"
                @blur="$v.register.firstname.$touch()"
                :error-messages="firstnameErrors"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0 pl-md-4"
            >
              <v-text-field
                label="Last Name *"
                v-model="register.lastname"
                @input="$v.register.lastname.$touch()"
                @blur="$v.register.lastname.$touch()"
                :error-messages="lastnameErrors"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0 pr-md-4"
            >
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFormat1"
                    label="Date of Birth *"
                    readonly
                    v-on="on"
                    @input="$v.register.dob.$touch()"
                    @blur="$v.register.dob.$touch()"
                    :error-messages="dobErrors"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="register.dob"
                  @input="menu1 = false"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1920-01-01"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6"
              class="py-0 pr-md-4"
            >
              <v-text-field
                label="E-mail *"
                v-model="register.email"
                @input="$v.register.email.$touch()"
                @blur="$v.register.email.$touch()"
                :error-messages="emailErrors"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0 pl-md-4"
            >
              <v-text-field
                label="Phone Number"
                v-model="register.phone"
                @input="$v.register.phone.$touch()"
                @blur="$v.register.phone.$touch()"
                :error-messages="phoneErrors"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              class="text-right"
            >
              <v-btn
                class="ma-2"
                tile
                outlined
                color="primary"
                :disabled="!tabs.signup.canSubmit"
                @click="checkUser"
              >
                <v-icon left>person_add</v-icon> Sign up
              </v-btn>
            </v-col>
          </v-row>


        </v-tab-item>
        
        <v-tab-item 
          class="py-5 px-8 text-left"
        >
          <p
            v-if="!$store.getters.hasLoggedin"
            class="title font-weight-light grey--text darken-2"
          >
            Already got an account?
          </p>
          <p
            v-else
            class="title font-weight-light"
          >
            Welcome Back {{ $store.state.contact.givenName }} {{ $store.state.contact.surname }}
          </p>

          <!--
          <v-btn
            :disabled="$store.getters.hasLoggedin"
            class="my-5"
            tile
            x-large
            outlined
            color="indigo"
          >
            Sign In with Social Media
            <v-icon right>
              mdi-google
            </v-icon>
            <v-icon right>
              mdi-facebook
            </v-icon>
            <v-icon right>
              mdi-apple
            </v-icon>
          </v-btn>

          
          <v-divider class="my-9"></v-divider> 

          <v-row
          >
            <v-col
              cols="12"
              md="6"
              class="py-0 pr-md-5"
            >
              <v-text-field
                label="Username *"
                v-model="login.username"
                @input="$v.login.username.$touch()"
                @blur="$v.login.username.$touch()"
                :error-messages="loginUsernameErrors"
                :disabled="$store.getters.hasLoggedin"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0 pl-md-5"
            >
              <v-text-field
                type="password"
                label="Password *"
                v-model="login.password"
                @input="$v.login.password.$touch()"
                @blur="$v.login.password.$touch()"
                :error-messages="loginPasswordErrors"
                :disabled="$store.getters.hasLoggedin"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              class="text-right"
            >
              <v-btn
                class="ma-2"
                tile
                outlined
                color="primary"
                :disabled="!tabs.signin.canSubmit"
                @click="userLogin"
              >
                <v-icon left>lock_open</v-icon> Login
              </v-btn>
            </v-col>
          </v-row>
          -->
          

        </v-tab-item>
        
      </v-tabs>

    </v-card>
  </div>


</template>

<script>
import axios from 'axios';
import axcelerate from './axcelerate.js';

import { validationMixin } from 'vuelidate'
import { required, email, minLength, helpers } from 'vuelidate/lib/validators'

var nameAllowChar  = helpers.regex('nameAllowChar', /^[a-zA-Z\d\s\-.]*$/);
var nameFormat     = helpers.regex('nameFormat', /^[a-zA-Z\d].*[a-zA-Z\d]$/);
var phoneAllowChar = helpers.regex('phoneAllowChar', /^[\d\s]*$/);
var phoneFormat    = helpers.regex('phoneFormat', /^[\d].*[\d]$/);

export default {
  props: ['clickedNext', 'currentStep'],
  mixins: [validationMixin],
  data() {
    return {
      loginURL: axcelerate.loginUrl() + encodeURIComponent(window.location.href + "&courseID=" + this.$store.state.course.instance) + "&provider=Google",
      selectedTab: 0,
      dialog: {
        loading: {
          visible: false,
          content: '',
        },
        response: {
          visible: false,
          banner: '',
          title: '',
          content: ''
        }
      },

      tabs: {
        signup: {
          canSubmit: false,
        },
        signin: {
          model: null,
          canSubmit: false,
        },
      },

      menu1: false,
      menu2: false,

      register: {
        firstname: '',
        lastname: '',
        dob: '',
        email: '',
        phone: '',
      },
      login: {
        username: '',
        password: '',
        accessCode: '',
        token: '',
      },
    }
  },

  created() {
    var params = {};
    var uri = decodeURI(window.location.href);
    uri.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function( m, key, value ) {
        params[ key ] = value;
      }
    );

    if( params.access_code !== undefined ) {
      this.login.accessCode = params.access_code;
      this.userLogin();
    }
  },

  validations: {
    register: {
      firstname: {
        required,
        minLength: minLength(2),
        nameAllowChar,
        nameFormat
      },
      lastname: {
        required,
        minLength: minLength(2),
        nameAllowChar,
        nameFormat
      },
      dob: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        minLength: minLength(2),
        phoneAllowChar,
        phoneFormat
      }
    },
    login: {
      username: {
        required
      },
      password: {
        required
      }
    },
  },
  computed: {
    firstnameErrors () {
      const errors = []
      if (!this.$v.register.firstname.$dirty) return errors
      !this.$v.register.firstname.required && errors.push('First name is required')
      !this.$v.register.firstname.minLength && errors.push('First name requires more than one character')
      !this.$v.register.firstname.nameAllowChar && errors.push('You can only use letters, numbers, space, hypen & period')
      !this.$v.register.firstname.nameFormat && errors.push('Only letters & numbers are allowed in the start and finish')
      return errors
    },
    lastnameErrors () {
      const errors = []
      if (!this.$v.register.lastname.$dirty) return errors
      !this.$v.register.lastname.required && errors.push('Last name is required')
      !this.$v.register.lastname.minLength && errors.push('Last name requires more than one character')
      !this.$v.register.lastname.nameAllowChar && errors.push('You can only use letters, numbers, space, hypen & period')
      !this.$v.register.lastname.nameFormat && errors.push('Only letters & numbers are allowed in the start and finish')
      return errors
    },
    dobErrors () {
      const errors = []
      if (!this.$v.register.dob.$dirty) return errors
      !this.$v.register.dob.required && errors.push('Date of birth is required')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.register.email.$dirty) return errors
      !this.$v.register.email.email && errors.push('Must be valid e-mail')
      !this.$v.register.email.required && errors.push('E-mail is required')
      return errors
    },
    phoneErrors () {
      const errors = []
      if (!this.$v.register.phone.$dirty) return errors
      !this.$v.register.phone.minLength && errors.push('Telephone requires more than one number')
      !this.$v.register.phone.phoneAllowChar && errors.push('You can only use numbers & space')
      !this.$v.register.phone.phoneFormat && errors.push('Only numbers are allowed in the start and finish')
      return errors
    },
    dateFormat1() {
      return this.formatDate( this.register.dob );
    },
    loginUsernameErrors() {
      const errors = []
      if (!this.$v.login.username.$dirty) return errors
      !this.$v.login.username.required && errors.push('Username is required')
      return errors
    },
    loginPasswordErrors() {
      const errors = []
      if (!this.$v.login.password.$dirty) return errors
      !this.$v.login.password.required && errors.push('Password is required')
      return errors
    },
  },
  methods: {
    parentLogin() {
      window.parent.smLogin();
    },

    formatDate( date ) {
      if( !date ) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    
    
    checkUser() {
      // this.dialog.loading.visible = true;
      // this.dialog.loading.content = "Checking if account is taken...";

      // axios.post( axcelerate.canRegister(), {
      //   'givenName': this.register.firstname,
      //   'surname': this.register.lastname,
      //   'email': this.register.email
      // } )
      // .then(response => {
        this.dialog.loading.visible = false;
        this.dialog.response.visible = true;

        // var canRegister = response.data;
        // If student can register
        // if( canRegister ) {

          this.$store.dispatch( 'setContact', {
            givenName   : this.register.firstname,
            surname     : this.register.lastname,
            dob         : this.register.dob,
            emailAddress: this.register.email,
            phone       : this.register.phone
          } );

          this.dialog.response.banner  = './joy1.jpg';
          this.dialog.response.title   = 'Hurray! ' + this.register.firstname;
          this.dialog.response.content = 'The name and email you nominated have not been taken.';

          this.tabs.signup.canSubmit = false;
          this.$emit('can-continue', {value: true});
        // } else {
        //   this.dialog.response.banner  = './not_available.jpg';
        //   this.dialog.response.title   = 'Account already exist',
        //   this.dialog.response.content = 'Hmmm... Looks like there is already an account with this name and email address. You may have an account with us already. If you forgot your login, try recovering your account.'
        // }
      // });
    },

    userLogin() {
      this.dialog.loading.visible = true;
      this.dialog.loading.content = "Logging into your learner portal...";

      // this.$recaptcha('login').then((token) => {
      //   this.login.token = token;

        axios.post( axcelerate.login(), this.login )
        .then(response => {
          this.dialog.loading.visible = false;
          this.dialog.response.visible = true;

          var login = response.data;

          // Assign Contact ID to session
          if( login.STATUS == "success" ) {
            this.$store.dispatch( 'setSessionContact', login.CONTACTID );
            this.$store.dispatch( 'setContact', {
              givenName   : login.GIVENNAME,
              surname     : login.SURNAME,
              dob         : login.DOB,
              emailAddress: login.EMAILADDRESS,
              phone       : login.PHONE
            } );
            this.$store.dispatch( 'setCoursesBooked', login.ENROLLED );

            this.tabs.signin.canSubmit = false;

            if( this.$store.getters.hasBooked ) {
              // Display already enrolled popup
              this.dialog.response.banner  = './thinking.png';
              this.dialog.response.title   = 'Login Succuessful, but wait...';
              this.dialog.response.content = 'Looks like you have already booked in ' + this.$store.state.course.name + '. Please go back and choose another course.';
              this.$store.dispatch( 'resetCourse' );
            } else {
              // Display welcome dialog popup
              this.dialog.response.banner  = './login.jpg';
              this.dialog.response.title   = 'Welcome back ' + login.GIVENNAME;
              this.dialog.response.content = 'Login successfully. Close popup and click Next to proceed.';
              this.$emit('can-continue', {value: true});
              this.selectedTab = 1;
            }

          } else {
            // Display incorrect login dialog pop up
            this.dialog.response.banner  = './not_found.jpg';
            this.dialog.response.title   = 'Login failed';
            // this.dialog.response.content = 'The username and password you entered is incorrect. Please try again.';
          }

        });

      // });


    }
  },
  watch: {
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menu2(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    $v: {
      handler: function (val) {

        // If register form is validated
        if(!val.register.$invalid) {
          // this.$store.dispatch( 'setContact', {
          //   givenName: this.register.firstname,
          //   surname: this.register.lastname,
          //   dob: this.register.dob,
          //   emailAddress: this.register.email,
          //   phone: this.register.phone
          // } );
          this.tabs.signup.canSubmit = true;
          this.$emit('can-continue', {value: false});

        } else {
          this.tabs.signup.canSubmit = false;
          this.$emit('can-continue', {value: false});
          setTimeout(()=> {
            this.$emit('change-next', {nextBtnValue: false});
          }, 3000)
        }

        // If sign in form is validated
        if(!val.login.$invalid) {
          this.tabs.signin.canSubmit = true;
        }

      },
      deep: true
    },

  },

  activated() {

    // If logged in OR Sign up form validated
    if( this.$store.getters.hasLoggedin || !this.$v.register.$invalid ) {
      this.$emit('can-continue', {value: true});
    } else {
      this.$emit('can-continue', {value: false});
    }

  }
}
</script>
